export const selectFilterGroups = (state) => state.mainReducer.filterGroups;